import React from "react"

// export { default as SMSSend } from './Manage'
// export { default as SMSSetting } from './ApplySetting'
// export { default as SMSStatistic } from './Statistics'

export default ({children}: any) => (<>{children}</>)